<template>
    <button
    :type="propriedades.htmlType || htmlType"
    :name="nome"
    :id="propriedades.id || id"
    :class="[
        'btn',
        propriedades.tipo || tipo,
        propriedades.classe,
        classe,
        { 'btn-loading': carregando },
    ]"
    :disabled="desabilitado || propriedades.disabled"
    @click="aoClicar"
>
        <template v-if="!carregando">
            <slot name="icon">
                <span
                    v-if="icone"
                    class="material-symbols-outlined"
                >
                    {{ icone }}
                </span>
            </slot>
            <span v-if="textoTraduzido">{{ textoTraduzido }}</span>
        </template>
        <template v-else>
            <div class="spinner-container">
                <span class="spinner-circular"></span>
            </div>
        </template>
    </button>
</template>

<script>
    import { defineComponent, ref, computed } from 'vue'
    import { useI18n } from 'vue-i18n'
    export default defineComponent({
        name: 'Botao',
        props: {
            propriedades: {
                type: Object,
                default: () => ({}),
            },
            nome: {
                type: String,
                default: '',
            },
            id: {
                type: String,
                default: '',
            },
            tipo: {
                type: String,
                default: 'button',
            },
            desabilitado: {
                type: Boolean,
                default: false,
            },
            carregando: {
                type: Boolean,
                default: false,
            },
            rotulo: {
                type: String,
                default: '',
            },
            icone: {
                type: String,
                default: null,
            },
            classe: {
                type: String,
                default: '',
            },
            htmlType: {
    type: String,
    default: 'button',
},
        },
        emits: ['clique'],
        setup(props, { emit }) {
            const { t, te } = useI18n()
            const aoClicar = () => {
                emit('clique')
            }

            const traduzirTexto = (valor) => {
                if (!valor) return ''

                if (typeof valor !== 'string') {
                    return valor
                }

                return te(valor) ? t(valor) : valor
            }

            const textoTraduzido = computed(() => {
                const texto = props.propriedades.rotulo || props.rotulo

                return traduzirTexto(texto)
            })

            const color = ref('red')
            const size = ref('20px')

            return {
                color,
                size,
                aoClicar,
                textoTraduzido,
            }
        },
    })
</script>

<style lang="scss" scoped>
    .btn.btn-icon {
        width: 100%;
        min-width: 2rem;
        height: 2.3rem;
        align-items: center;
        display: flex;
        justify-content: center;
        padding: 0.313rem 0.438rem;
        font-size: 1.4rem;
        text-transform: none;
        border-radius: 20%;
    }
    .btn:hover:enabled,
    .btn:active:enabled {
        background-color: var(--colorOpacity100);
        border: 0.1vh solid var(--colorOpacity100);
        color: var(--white);
    }

    .btn:disabled {
        cursor: not-allowed;
        background-color: #ddd;
        background: #ddd;
        border: 0.1vh solid #ddd;
    }

    .btn-xs-white:hover:enabled,
    .btn-xs-white:active:enabled {
        background-color: var(--colorOpacity100);
        border: 0.1vh solid var(--colorOpacity100);
    }

    .btn-xs-red-large:hover:enabled,
    .btn-xs-red-large:active:enabled {
        background-color: #de0d0d;
        border: 0.1vh solid #de0d0d;
    }

    .btn-xs-white:disabled {
        cursor: not-allowed;
        border: 0.1vh solid #ddd;
        background-color: #ddd;
        background: #ddd;
    }

    .btn-white:hover:enabled,
    .btn-white:active:enabled {
        background-color: var(--colorOpacity5);
        border: 0.1vh solid var(--colorOpacity60);
        color: var(--colorOpacity100);
    }

    .btn-xs-white-large-delete:hover:enabled,
    .btn-xs-white-large-delete:active:enabled {
        background-color: red;
        border: 0.1vh solid var(--colorOpacity60);
        color: white;
    }

    .btn-white-error:hover:enabled {
        background-color: #de0d0d;
        border: 0.1vh solid #de0d0d;
        color: #ffffff;
    }

    .btn-white:disabled {
        cursor: not-allowed;
        border: 0.1vh solid #ddd;
        background-color: #ddd;
        background: #ddd;
    }

    .btn-loading {
        position: relative;
        pointer-events: none;
        opacity: 0.8;
    }
    .spinner-container {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
        width: 100%;
    }

    .spinner-circular-gradiente {
        display: inline-block;
        width: 1rem;
        height: 1rem;
        border-radius: 50%;
        animation: spin-gradiente 0.75s linear infinite;
        background: conic-gradient(#ffffff, var(--colorOpacity100));
        -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 0.15rem), #fff 0);
        mask: radial-gradient(farthest-side, transparent calc(100% - 0.15rem), #fff 0);
    }

    @keyframes spin-gradiente {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }

    .spinner-circular {
        display: inline-block;
        width: 1.25rem;
        height: 1.25rem;
        border: 2px solid currentColor;
        border-radius: 50%;
        border-right-color: transparent;
        animation: spin 0.75s linear infinite;
        color: var(--colorOpacity100);
    }

    @keyframes spin {
        to {
            transform: rotate(360deg);
        }
    }

    .button {
        display: flex;
        line-height: normal;
        justify-content: flex-end;
    }

    .btn {
        background-color: var(--colorOpacity60);
        border: 0.1vh solid var(--colorOpacity60);
        width: auto;
        text-align: center;
        padding: 0.5rem;
        white-space: nowrap;
        color: var(--white);
        font-family: var(--roboto);
        font-size: 1rem;
        font-weight: 500;
        letter-spacing: 0;
        line-height: normal;
        text-transform: uppercase;
        border-radius: 0.5rem;
        cursor: pointer;
        transition: all 0.2s ease-in-out;
    }

    .btn-primary:disabled {
        cursor: not-allowed;
        background-color: #ddd;
        background: #ddd;
        border: 0.1vh solid #ddd;
        color: #b5aeae;
    }

    .btn-primary {
        padding: 8px 20px;
        text-transform: none;
        font-size: 1rem;
    }
    .btn-secondary {
        font-size: 1rem;
        padding: 8px 20px;
        text-transform: none;
        background-color: var(--white);
        border: 0.1vh solid #b5aeae;
        color: #464646;
    }

    .btn-tertiary:disabled {
        cursor: not-allowed;
        background-color: #ddd;
        background: #ddd;
        border: 0.1vh solid #ddd;
        color: #b5aeae;
    }
    .btn-tertiary {
        padding: 8px 20px;
        text-transform: none;
        font-size: 1rem;
        background-color: var(--white);
        color: var(--colorOpacity60);
        border: 0.1vh solid var(--colorOpacity60);
    }

    .btn-white {
        font-size: 1rem;
        padding: 8px 20px;
        background-color: var(--white);
        border: 0.1vh solid var(--colorOpacity60);
        color: var(--colorOpacity100);
    }

    .btn-s-white {
        background-color: var(--white);
        border: 0.1vh solid var(--colorOpacity60);
        color: var(--colorOpacity100);
        font-size: 1rem;
        padding: 8px 20px;
        text-transform: none;
    }

    .btn-xs-small {
        border: 0.1vh solid var(--colorOpacity60);
        color: var(--colorOpacity100);
        font-size: 1rem;
        padding: 8px 20px;
        text-transform: none;
        color: #fff;
    }

    .btn-xs-send {
        border: 0.1vh solid var(--colorOpacity60);
        color: var(--colorOpacity100);
        font-size: 1rem;
        padding: 8px 20px;
        text-transform: none;
        color: #fff;
    }

    .btn-xs-white {
        background-color: var(--white);
        border: 0.1vh solid #e0e0e0;
        font-size: 1rem;
        padding: 8px 20px;
        text-transform: none;
        color: var(--colorOpacity60);
    }

    .btn-xl-buy {
        width: 14vw;
        justify-content: center;
        display: flex;
        align-items: center;
        gap: 0.4vw;
        font-size: var(--font-size-l);
        text-transform: capitalize;
        text-decoration: none;
    }

    .btn-header {
        font-size: 1.125rem;
        justify-content: center;
        display: flex;
        align-items: center;
        padding: 10px 20px;
        text-transform: none !important;
        text-decoration: none;
    }

    .btn-large {
        font-size: 1.125rem;
        justify-content: center;
        display: flex;
        align-items: center;
        padding: 10px 20px;
        text-transform: capitalize;
        text-decoration: none;
    }

    .btn-circle {
        width: 2.7vw;
        height: 2.7vw;
        border-radius: 20vh;
    }

    .btn-mobile {
        display: none;
    }

    .btn-xs-white-large-delete {
        background-color: var(--white);
        border: 0.1vh solid rgb(210, 199, 199);
        font-size: var(--font-size-l);
        text-transform: none;
        font-weight: 600;
        color: red;
    }

    .btn-xs-white-small {
        background-color: var(--white);
        border: 0.1vh solid var(--colorOpacity20);
        font-size: var(--font-size-s);
        font-weight: 700;
        width: 5vw;
        height: 3vh;
        text-transform: none;
        color: var(--colorOpacity60);
    }

    .btn-xs-white-large {
        background-color: var(--white);
        border: 0.1vh solid var(--colorOpacity20);
        font-size: var(--font-size-l);
        font-weight: 700;
        text-transform: none;
        color: var(--colorOpacity60);
    }

    .btn-xs-red-large {
        background-color: var(--white);
        border: 0.1vh solid #c00000;
        font-size: var(--font-size-l);
        width: 7vw;
        height: 5.7vh;
        text-transform: none;
        font-weight: 400;
        color: #c00000;
    }

    .btn-xs-large {
        border: 0.1vh solid var(--colorOpacity60);
        font-size: var(--font-size-l);
        width: 7vw;
        height: 5vh;
        text-transform: none;
        color: #fff;
    }

    .btn-white-error {
        background-color: #fff;
        border: 0.1vh solid #de0d0d;
        font-size: var(--font-size-s);
        width: 5vw;
        height: 4.2vh;
        color: #de0d0d;
        text-transform: capitalize;
    }

    .btn-xs-crop {
        border: 0.1vh solid var(--colorOpacity60);
        color: var(--colorOpacity100);
        font-size: var(--font-size-m);
        width: 5vw;
        height: 4.2vh;
        text-transform: none;
        background-color: #fff;
    }

    .btn-large-upper {
        width: 10rem;
        text-transform: uppercase;
    }
</style>
